<div class="spinner center" data-automationid="loading">
  <div class="spinner-blade"></div>
  <div class="spinner-blade"></div>
  <div class="spinner-blade"></div>
  <div class="spinner-blade"></div>
  <div class="spinner-blade"></div>
  <div class="spinner-blade"></div>
  <div class="spinner-blade"></div>
  <div class="spinner-blade"></div>
  <div class="spinner-blade"></div>
  <div class="spinner-blade"></div>
  <div class="spinner-blade"></div>
  <div class="spinner-blade"></div>
</div>
